module.exports = __webpack_public_path__ + "static/media/Roboto-RegularItalic.a720f17a.ttf";